import React, { useEffect, useState } from 'react'
import Tools from '../../../Misc/Tools';
import { UIBaseImplementation } from '../../../UI/UIBaseImplementation';
import { UIProperties } from '../UIProperties';
import CoreGeneralButton from './core-general-button';

import "./core-general-question-ui.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../../../misc/tools';
import SoundManager from '../../../Sound/SoundManager';
import { GameBaseScenario } from '../../../../scenarios/GameBaseScenario';

export interface GeneralQuestionUIBaseImplementation {
	init: (onForceUpdate: () => void) => void;
	getSelectedOptionsLength: () => number;
	getSelectedOptions: () => number[] | number;
	isOptionSelected: (index: number) => boolean;
	onOptionSelected: (option: GeneralQuestionUIConfigOption, selectedIndx: number, onForceUpdate: () => void) => void;
	onQuestionSubmitted: () => void;
}


class CoreGeneralQuestionUIBaseImplementation extends UIBaseImplementation {
	private selectedOptionIndices: number[] = [];
	private soundManager: SoundManager;
	private soundId: string = undefined;

	private timeout: any = null
	private submitted: boolean = false

	public getImplementation(config: GeneralQuestionUIConfig): GeneralQuestionUIBaseImplementation {
		return {
			init: (onForceUpdate: () => void) => {
				this.selectedOptionIndices = [];
				this.submitted = false;
				onForceUpdate();
				this.soundManager = (window as any)['core-gm']?.SoundManager;
				if(config.audioUrl && this.soundManager) {
					const context = this;
					this.timeout = setTimeout(() => {
						this.soundManager.playSound({
							src: config.audioUrl,
							controls: false,
							enableClosedCaptioning: false,
							muted: (window as any)['muted-audio'],
							oneShot: true,
							onEnded: () => {
								context.soundId = undefined;
							},
							onShouldAbortPlaying: () => {
								return this.submitted;
							}
						}, (id: string) => {
							context.soundId = id;
						});
					}, 1000);
					
				}
			},
			getSelectedOptionsLength: () => {
				return this.selectedOptionIndices.length;
			},
			getSelectedOptions: () => {
				return config.multipleChoice ? [...this.selectedOptionIndices] : (this.selectedOptionIndices[0] ?? -1);
			},
			isOptionSelected: (index: number) => {
				return this.selectedOptionIndices.indexOf(index) !== -1;
			},
			onOptionSelected: (option: GeneralQuestionUIConfigOption, selectedIndx: number, onForceUpdate: () => void) => {
				option.isSelected = !option.isSelected;
		
				if(config.multipleChoice) {
					const foundIndex = this.selectedOptionIndices.indexOf(selectedIndx);
		
					if(option.isSelected) {
						if(foundIndex === -1) {
							this.selectedOptionIndices.push(selectedIndx);
						}
					} else {
						if(foundIndex !== -1) {
							this.selectedOptionIndices.splice(foundIndex, 1);
						}
					}
				} else {
					if(this.selectedOptionIndices.length === 1 && this.selectedOptionIndices[0] === selectedIndx) {
						for(var indx = 0; indx < config.options.length; indx++) {
							config.options[indx].isSelected = false;
						}
						this.selectedOptionIndices = [];
					} else {
						for(var indx = 0; indx < config.options.length; indx++) {
							if(indx !== selectedIndx) {
								config.options[indx].isSelected = false;
							}
						}
						this.selectedOptionIndices = [selectedIndx];
					}
					
				}
				onForceUpdate();
			},
			onQuestionSubmitted: () => {
				this.submitted = true;
				if(this.soundId) {
					this.soundManager.stopSound(this.soundId)
				}
				if(this.timeout) {
					clearTimeout(this.timeout);
					this.soundManager.stopAllSounds();
				}
				// config.onSubmitClicked(config.options, config.options.filter(o => o.isSelected), config);
			}
		}
	}
}

export const coreGeneralQuestionUIBaseImplementation = new CoreGeneralQuestionUIBaseImplementation();

const CoreGeneralQuestionUI = (props: UIProperties<GeneralQuestionUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(0);
	const baseImplementation = coreGeneralQuestionUIBaseImplementation.getImplementation(props.parameters);

	useEffect(() => {
		if(forceUpdate === 0) {
			baseImplementation.init(() => {
				setForceUpdate(forceUpdate+1);
			});
		}
	})

	return (
		<div className="modal-disable-select core-general-question-ui-container" style={{
		}}>
			<div className='core-general-question-ui-inner-container center-element'>
				<div className="modal-disable-select center-element core-general-question-ui-inner-cont-container" style={{
				}}>
					<div className='core-general-question-ui-inner-cont-row-right' style={{height: '140px'}}>
						<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='title-text core-general-question-ui-inner-cont-title'>{props.parameters.questionTitle}</p>
					</div>

					<div className='core-general-question-ui-inner-cont-description core-general-question-ui-inner-cont-row' style={{marginBottom: '10px'}}>
						<div className='core-general-question-ui-sub-container center-element-horizontal'>
								<div className='core-general-question-ui-sub-container-question-title'>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='center-element default-text'>{props.parameters.questionTitle}</p>
								</div>
								<form>
									{props.parameters.options.map((option: GeneralQuestionUIConfigOption, index: number) => {
										return (
											<div style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='core-general-question-ui-sub-container-question-single-option' 
												key={Tools.generateGuid()} onClick={() => {baseImplementation.onOptionSelected(option, index, () => {
													setForceUpdate(forceUpdate+1);
												})}}>
													<input onChange={() => {}} type={props.parameters.multipleChoice ? 'checkbox' : 'radio'} checked={baseImplementation.isOptionSelected(index)} />
													<span>{option.title + ': ' + option.description}<span style={{color: option.score === 0 ? 'red' : 'green'}}>{' Score: ' + option.score  + ' pts; '}</span>
													<span dangerouslySetInnerHTML={{ __html: 
															(option.isCorrect ? '<span style="color: green">Correct</span>' : '<span style="color: red">Incorrect</span>')}}></span></span>
											</div>
										)
									})}
								</form>
								

								<div className='center-element-horizontal core-general-question-ui-sub-container-question-submit'>
									<CoreGeneralButton width= '100%'
										height= '100%'
										onClick= {() => {baseImplementation.onQuestionSubmitted()}}
										onRenderContent= {() => {
											return (
												<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text center-element'>Submit</p>
											)
										}}
										isSelected= {false}
										isDisabled={baseImplementation.getSelectedOptionsLength() === 0}
										ariaLabel= {'Submit'}></CoreGeneralButton>
								</div>
										
						</div>
					</div>
				</div>
			</div>
		</div>
	);

};

export interface GeneralQuestionUIConfig {
	questionTitle: string;
	options: GeneralQuestionUIConfigOption[];
	onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => void;
	multipleChoice?: boolean;
    audioUrl?: string;
}

export interface GeneralQuestionUIConfigOption {
	title: string;
	description: string;
	feedbackHtml: string;
	isCorrect: boolean;
	isSelected?: boolean;
	score: number;
}

export default CoreGeneralQuestionUI;